/**
 * Test IDs for QA automation.
 */
export const testIds = {
  demoUtilsSaveSnapshot: "demo-utils-save-snapshot",
  demoUtilsRestoreSnapshot: "demo-utils-restore-snapshot",
} as const;
